import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import Filled_Star from "../assets/Filled Star.png";
import { Navigate, useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import StarGen from "./StarSet.jsx";
import lock from "../assets/lock.jpg";
import unlock from "../assets/unlock.jpeg";
import Modal from "./Modal";
import dropdown from "../assets/NewDropdown.webp"
import loadPosts from "./Posts.jsx";
import commentButton from "../assets/CommentButton.png";
import trash from "../assets/trashCan.png";





const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
const basePath = isLocalhost
  ? ""
  : "https://webdev.cse.buffalo.edu/hci/teams/indecisive";

console.log("Environment check:", {
  isLocalhost,
  hostname: window.location.hostname,
  basePath
});

const Post = ({ parent, // ID of the parent post to which the comment belongs
  loadPosts, // Function to reload posts
  loadComments, // Function to reload comments
}) => {

  // useState to manage the post text
  const [postText, setPostText] = useState("");
  // useState to manage the status message after posting
  const [postMessage, setPostMessage] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoaded, setIsLoaded] = useState(false);
  //adding the image and title aspects into this
  const [postImage, setPostImage] = useState("");
  const [postTitle, setPostTitle] = useState("");
  const [postContent, setPostContent] = useState("");
  const [postAuth, setPostAuth] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [username, setUsername] = useState("");
  const [privatePost, setPrivatePost] = useState("");

  // New refs to track image loading status
  const postImageLoaded = useRef(false);
  const dishImageLoaded = useRef(false);
  const imagesBeingLoaded = useRef(0);
  const allDataFetched = useRef(false);

  const [newComment, setNewComment] = useState("");
  const [comments, setComments] = useState([]);
  const [showCommentBox, setShowCommentBox] = useState(false);


  // Post details for information section
  const [restaurantName, setRestaurantName] = useState("");
  const [dishName, setDishName] = useState("");
  const [categories, setCategories] = useState([]);
  const [dishDescription, setDishDescription] = useState("");
  const [dishImage, setDishImage] = useState("");
  const [overallRating, setOverallRating] = useState(5);
  //restrictions for website, needs to be a file less than 
  const MAX_FILE_SIZE = 1024 * 1024; // 
  const [authorUsername, setAuthorUsername] = useState("");
  const [commentUsernames, setCommentUsernames] = useState({});
  const [authorId, setAuthorId] = useState("");
  const [dishId, setDishId] = useState(null);
  const [dishDetails, setDishDetails] = useState(null);
  const [restaurantId, setRestaurantId] = useState(null);
  // Viewer Information (Checking if blocking is enabled)
  const myUserId = sessionStorage.getItem("user");
  let accountJSON = sessionStorage.getItem("accountJSON");
  const [postsBlocked,setPostBlocked] = useState(false);
  const [currBlocked, setCurrBlocked] = useState(false);
  const [accountBlocked, setAccountBlock] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const userToken = sessionStorage.getItem("token");
  const [connectionID, setConnectionID] = useState(null);
  //Wait for loading to be finished
  const [unloaded, setUnloaded] = useState(true);
  const MAX_REVIEW_WORDS = 250;
  const blockedPosts = sessionStorage.getItem("blockedPosts");
  const blockedProfiles = sessionStorage.getItem("blockedProfiles");
  const blockingProfiles = sessionStorage.getItem("blockingProfiles");
  const [blockingList, setBlockingList] = useState([]);
  const [confirmBlock,setConfirmBlock] = useState(false);
  const [open, setOpen] = useState(false);
  const [openBlock, setOpenBlock] = useState(false);
  const [fetched, setFetched] = useState(false);

  
  

  // Add a check to ensure all images are loaded - MOVED TO TOP LEVEL
  useEffect(() => {
    // This effect checks if we need to update isLoaded based on image loading status
    if (allDataFetched.current && imagesBeingLoaded.current === 0 && !isLoaded) {
      // All data fetched and all images loaded, but isLoaded is still false
      setTimeout(() => {
        setIsLoaded(true);
      }, 150);
    }
  }, [isLoaded]); // Changed dependencies to avoid the ref.current which can cause lint issues

  useLayoutEffect(() => {
    // Reset image loading status refs when loading a new post
    postImageLoaded.current = false;
    dishImageLoaded.current = false;
    imagesBeingLoaded.current = 0;
    allDataFetched.current = false;
    
    getPost(id);
    loadComment();
  }, [id, showModal]);

  const handleClose = () => {
    setOpen(false);
};

const handleOpen = () => {
    setOpen(true);
}; 

const handleOpenBlock = () => {
  setOpenBlock(true);
}

const closeOpenBlock = () => {
  setOpenBlock(false);
}

function BlockModal({ onClose }) {
  return (
    <div className="pref-pop">
      <div>
        <h3 className="fredoka-custom">Are you sure you want to block this user?</h3>

<br></br> <br></br>
        <button style={{marginRight: "90px"}} className="close-pref" onClick={handleBlockPost}>
          Yes
        </button>
        
        <button className="close-pref" onClick={handleClose}>
          No
        </button>
      </div>
    </div>
  );
}

const fetchUserData = async () => {
    try {
      // Fetch user details
      const response = await fetch(
        `${process.env.REACT_APP_API_PATH}/users/${myUserId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${userToken}`,
          },
        }
      ); 

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error("Failed to fetch user data. Status:", response.status, "Response:", errorData);
        throw new Error(errorData.message || `Failed to fetch user data (${response.status})`);
      }
      const result = await response.json();
      // console.log("RESULTS!");
      // console.log(result);
      const newList = [];
      for (let entry in result.attributes.blockedPosts){
        // console.log(entry);
        blockingList.push(parseInt(entry));
      }
      // console.log("This is the new List!")
      // console.log(blockingList);
      setFetched(true);
      // console.log(blockingList.indexOf(id));
      // console.log(typeof blockingList[1]);
      // console.log(typeof id);
      if (blockingList.includes(parseInt(id))) {
        setCurrBlocked(true);
      }
    }
    catch (err) {
      return;
    }
  }

  useLayoutEffect(() => {
    fetchUserData();
    // console.log(blockingList.includes(parseInt(id)));
    if (blockingList.includes(parseInt(id))) {
      setCurrBlocked(true);
    }
    else {
      setCurrBlocked(false);
    }
  })

  // useLayoutEffect(() => {
  //   console.log("THIS IS THE ACCOUNT JSON")
  //   console.log(JSON.parse(accountJSON));
  // },[accountJSON]);

  useLayoutEffect(() => {
    if(sessionStorage.getItem("blockingProfiles") != null) {
      if (blockingProfiles.includes(authorId)) {
        // console.log("THIS IS HAPPENING!!!!");
        setAccountBlock(true);
        // console.log("BLOCKED PROFILES");
        // console.log(blockedProfiles)
      }
      else {
        setAccountBlock(false);
      }

    // console.log(blockingList.includes(parseInt(id)))
    // if (blockingList.includes(parseInt(id))) {
    //   setCurrBlocked(true);
    // }
    // else {
    //   setCurrBlocked(false);
    // }
    }
  })


  async function handleUnblockPost() {
    const currID = id;
    const newJSON = JSON.parse(accountJSON);
    // console.log("HERE IS THE JSON POST PRE DELETION");
    // console.log(newJSON);
    delete newJSON["attributes"]["blockedPosts"][`${id}`];
    
    // console.log("THIS IS THE NEW JSON POST DELETION");
    // console.log(newJSON);

    try {
      // console.log("NEW JSON");
      // console.log(newJSON);
      const response = await fetch(
        `${process.env.REACT_APP_API_PATH}/users/${myUserId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify(newJSON),
        }
      )

      // console.log("SENT!!!");

      if (!response.ok) {
        // const errorBody = await response.text();
        // console.error(`Failed to update description. Status: ${response.status}, Body: ${errorBody}`);
        throw new Error("Failed to block page.");
      };

      if (response.ok) {
        accountJSON = JSON.stringify(newJSON);
      }

    } catch (error) {
      console.error("Error blocking post:", error);
      
    }
    // console.log("SETTING CURR BLOCKED TO FALSE");
    fetchUserData();
    accountJSON = JSON.stringify(newJSON);
    setBlockingList([]);
  }

  function openConfirmBlock() {
    setConfirmBlock(true);
  }
 
  async function handleBlockPost() {
    // console.log("DATA IS HERE!");
    // console.log(accountJSON);
    // console.log(sessionStorage.getItem("accountJSON"));
    const newJSON = JSON.parse(sessionStorage.getItem("accountJSON"));
    // const newJSON = JSON.parse(accountJSON);
    // console.log("START  OF BLOCK FUNCTION")
    if (newJSON.attributes.blockedPosts == null) {
      newJSON.attributes.blockedPosts = {[id] : true}
    }

    else {
      newJSON.attributes.blockedPosts[id] = true;
    }

    try {
      // console.log("NEW JSON");
      // console.log(newJSON);
      const response = await fetch(
        `${process.env.REACT_APP_API_PATH}/users/${myUserId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify(newJSON),
        }
      )

      // console.log("SENT!!!");

      if (!response.ok) {
        // const errorBody = await response.text();
        // console.error(`Failed to update description. Status: ${response.status}, Body: ${errorBody}`);
        throw new Error("Failed to block page.");
      };

      if (response.ok) {
        // console.log("CHANGING ACCOUNTJSON");
        accountJSON = JSON.stringify(newJSON);
      }

    } catch (error) {
      console.error("Error blocking post:", error);
     
    }
    // console.log("SETTING CURR BLOCKED TO TRUE");
    setCurrBlocked(true);
    // console.log(currBlocked);
    // console.log("THESE ARE BLOCKED POSTS");
    // console.log(blockedPosts);
    setConfirmBlock(false);
    setBlockingList([]);
    handleClose();
  }

  const getPost = (postID) => {
    setIsLoaded(false);
    
    const token = sessionStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers["Authorization"] = "Bearer " + token;
    }

    fetch(`${process.env.REACT_APP_API_PATH}/posts/${id}`, {
      method: "GET",
      headers: headers,
    })
      .then((res) => res.json())
      .then(async (result) => {
        if (result) {
          console.log("Post API Response:", {
            id: result.id,
            content: result.content,
            attributes: result.attributes,
            path: result.path,
            image: result.attributes?.image
          });
          
          // Set basic data immediately
          setPostTitle(result.attributes?.title || "");
          setPostContent(result.content || "");
          setPostAuth(result.authorID || "");
          setAuthorId(result.authorID || "");
          setPrivatePost(result.attributes?.private || false);
          setOverallRating(result.attributes?.overallRating || result.attributes?.rating || 5);

          // Get the dish ID from the post
          const postDishId = result.attributes?.dishID;
          setDishId(postDishId);

          // Track image loading with a promise
          const imageLoadPromises = [];

          try {
            // Import the dishes data
            const dishesData = await import('../assets/dishes2.json');
            // Find the matching dish
            const matchingDish = dishesData.default.find(dish => dish.id === Number(postDishId));

            if (matchingDish) {
              setDishDetails(matchingDish);
              setRestaurantName(matchingDish.restaurantName);
              setDishName(matchingDish.title);
              setCategories(matchingDish.tags || []);
              setDishDescription(matchingDish.description);

              // Fetch restaurant data from public folder
              try {
                const restaurantsResponse = await fetch(
                  isLocalhost
                    ? "/data/restaurants.json"
                    : `${basePath}/data/restaurants.json`
                );                
                const restaurantsData = await restaurantsResponse.json();
                const matchingRestaurant = restaurantsData.restaurants.find(
                  restaurant => restaurant.name === matchingDish.restaurantName
                );
                if (matchingRestaurant) {
                  setRestaurantId(matchingRestaurant.id);
                }
              } catch (error) {
                console.error("Error fetching restaurant data:", error);
              }

              // Handle dish image from dishes2.json
              if (matchingDish.image) {
                const dishImageUrl = matchingDish.image.startsWith("/")
                  ? `${basePath}${matchingDish.image}`
                  : matchingDish.image;
                
                // Track this image load
                imagesBeingLoaded.current++;

                // Create a Promise for the dish image loading
                const dishImagePromise = new Promise((resolve) => {
                  const img = new Image();
                  img.onload = () => {
                    // Add a small delay to ensure DOM updates
                    setTimeout(() => {
                      setDishImage(dishImageUrl);
                      dishImageLoaded.current = true;
                      imagesBeingLoaded.current--;
                      resolve();
                    }, 100);
                  };
                  img.onerror = () => {
                    // Try an alternative format if needed
                    if (dishImageUrl.includes('webdev.cse.buffalo.edu') && !dishImageUrl.includes(basePath)) {
                      try {
                        const pathPart = dishImageUrl.split('webdev.cse.buffalo.edu')[1];
                        setDishImage(`${basePath}${pathPart}`);
                      } catch (err) {
                        setDishImage(dishImageUrl); // Use original URL as fallback
                      }
                    } else {
                      setDishImage(dishImageUrl); // Use original URL as fallback
                    }
                    dishImageLoaded.current = true;
                    imagesBeingLoaded.current--;
                    resolve();
                  };
                  img.src = dishImageUrl;
                });
                
                imageLoadPromises.push(dishImagePromise);
              }
            } else {
              // Fallback to post attributes if no matching dish found
              setRestaurantName(result.attributes?.restaurant || "Unknown Restaurant");
              setDishName(result.attributes?.title || "Unknown Dish");
              setCategories(result.attributes?.tags || []);
              setDishDescription(result.attributes?.description || "No description available");
            }
          } catch (error) {
            console.error("Error loading dish details:", error);
            // Fallback to post attributes if error loading dishes data
            setRestaurantName(result.attributes?.restaurant || "Unknown Restaurant");
            setDishName(result.attributes?.title || "Unknown Dish");
            setCategories(result.attributes?.tags || []);
            setDishDescription(result.attributes?.description || "No description available");
          }

          // Handle post image
          if (result.attributes?.image) {
            const imageUrl = result.attributes.image.startsWith("/") 
              ? `${basePath}${result.attributes.image}`
              : result.attributes.image.startsWith("http")
                ? result.attributes.image
                : `https://webdev.cse.buffalo.edu${result.path}`;
            
            // Track this image load
            imagesBeingLoaded.current++;
            
            // Create a Promise for the post image loading
            const postImagePromise = new Promise((resolve) => {
              const img = new Image();
              img.onload = () => {
                // Add a small delay to ensure DOM updates
                setTimeout(() => {
                  setPostImage(imageUrl);
                  postImageLoaded.current = true;
                  imagesBeingLoaded.current--;
                  resolve();
                }, 100);
              };
              img.onerror = () => {
                // Try alternate URL format if the first one fails
                const fallbackUrl = imageUrl.includes('webdev.cse.buffalo.edu') && !imageUrl.includes(basePath)
                  ? `${basePath}${imageUrl.split('webdev.cse.buffalo.edu')[1]}`
                  : imageUrl;
                
                // Try loading with fallback URL
                const fallbackImg = new Image();
                fallbackImg.onload = () => {
                  setTimeout(() => {
                    setPostImage(fallbackUrl);
                    postImageLoaded.current = true;
                    imagesBeingLoaded.current--;
                    resolve();
                  }, 100);
                };
                fallbackImg.onerror = () => {
                  setPostImage(""); // Empty string if all attempts fail
                  postImageLoaded.current = true;
                  imagesBeingLoaded.current--;
                  resolve();
                };
                fallbackImg.src = fallbackUrl;
              };
              img.src = imageUrl;
            });
            
            imageLoadPromises.push(postImagePromise);
          } else if (result.path) {
            const imageUrl = `https://webdev.cse.buffalo.edu${result.path}`;
            
            // Track this image load
            imagesBeingLoaded.current++;
            
            // Create a Promise for this path-based image
            const pathImagePromise = new Promise((resolve) => {
              const img = new Image();
              img.onload = () => {
                setTimeout(() => {
                  setPostImage(imageUrl);
                  postImageLoaded.current = true;
                  imagesBeingLoaded.current--;
                  resolve();
                }, 100);
              };
              img.onerror = () => {
                setPostImage(""); // Empty string if loading fails
                postImageLoaded.current = true;
                imagesBeingLoaded.current--;
                resolve();
              };
              img.src = imageUrl;
            });
            
            imageLoadPromises.push(pathImagePromise);
          } else {
            setPostImage(""); // Set empty to show "No image available"
            postImageLoaded.current = true;
          }

          // Fetch author details
          await fetchAuthorDetails(result.authorID);

          if (result.attributes.private) {
            await checkIfFollower(result.authorID);
          }
          
          // Mark that all data has been fetched
          allDataFetched.current = true;
          
          // Wait for all image loading promises to complete
          if (imageLoadPromises.length > 0) {
            Promise.all(imageLoadPromises).then(() => {
              // Add a final short delay to ensure all state updates are processed
              setTimeout(() => {
                setIsLoaded(true);
              }, 150);
            });
          } else {
            // No images to load, we can set isLoaded immediately
            setTimeout(() => {
              setIsLoaded(true);
            }, 150);
          }
        }
      })
      .catch((err) => {        
        console.error("Error loading post:", err);
        setIsLoaded(true);
      });
  };

  const fetchAuthorDetails = (authorID) => {
    //if (!authorID) return;
    if (!authorID || commentUsernames[authorID]) return;

    const token = sessionStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers["Authorization"] = "Bearer " + token;
    }

    fetch(`${process.env.REACT_APP_API_PATH}/users/${authorID}`, {
      method: "GET",
      headers: headers,
    })
      .then((res) => res.json())
      .then((result) => {
        if (result && result.attributes && result.attributes.username) {
          setAuthorUsername(result.attributes.username);
        } else {
          setAuthorUsername(`User ${authorID}`);
        }

      })
      .catch((error) => {
        console.error("Error fetching author details:", error);
        setAuthorUsername(`User ${authorID}`);
      });
  };












  const handleDelete = () => {
    // console.log("This is the session storage: ", sessionStorage.getItem("user"), postAuth);
    if (sessionStorage.getItem("user") == postAuth) {
      setErrorMessage("Post deleted successfully");
      navigate("/"); //Redirect to homepage or another page
    } else {
      setErrorMessage("You can not delete this post");
      return;
    }

    fetch(process.env.REACT_APP_API_PATH + "/posts/" + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((res) => res.json())

      .then((result) => {
        setShowModal(false);  // Close modal
        navigate(`/reviewPost`)
      })
      .catch((err) => {
        // console.log("ERROR deleting post", err);
      });
  };

  const handleEdit = (event) => {
    event.preventDefault();
    fetch(`${process.env.REACT_APP_API_PATH}/posts/${id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({
        authorID: sessionStorage.getItem("user"),
        attributes: {
          title: postTitle,
          image: postImage,
          private: privatePost,
          overallRating: overallRating,
          dishID: dishId,
          restaurant: restaurantName,
          description: dishDescription,
          tags: categories,
          dishImage: dishImage,
          author: {
            attributes: {
              username: username,
            }
          }
        },
        content: postContent
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          // console.log("API Response:", result); // Debugging line
          navigate(`/reviewPost/edit/${result.id}`)
        },
        (error) => {
          setErrorMessage("Error Submitting Post. Please try again.");
        }
      );
  };


  const checkIfFollower = (authorID) => {
    const userID = sessionStorage.getItem("user");

    fetch(`${process.env.REACT_APP_API_PATH}/connections?toUserID=${userID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.length === 0) {
          setErrorMessage("This post is private. You must follow this user to view it.");
          navigate("/"); // Redirect to homepage
        }
      })
      .catch(() => {
        setErrorMessage("Error checking follower status.");
      });
  };


  // Helper function to handle image loading errors
  const handleImageError = (e, fallbackSrc = "/placeholder.png") => {
    e.target.onerror = null; // Prevent infinite loop
    e.target.src = fallbackSrc;
  };

  const handlePrivacy = (e) => {
    setPrivatePost(!privatePost);
    if (setPrivatePost == true) {
      <img className="LockingPhoto" src={lock} alt="Locking"></img>
    }
    if (setPrivatePost == false) {
      <img className="LockingPhoto" src={unlock} alt="Locking"></img>
    }
  };

  //Block Checking
  const blockChecking = async (e) => {
    const followCheckResponse = await fetch(
      `${process.env.REACT_APP_API_PATH}/connections?fromUserID=${authorId}&toUserID=${myUserId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        }
      }
    )

    if (followCheckResponse.ok) {
      const followData = await followCheckResponse.json();
      if (followData[0] && followData[0].length > 0) {
        const connection = followData[0][0];
        //console.log(connection);
        setConnectionID(connection.id);
        if (connection.attributes?.additionalProp1?.block) {
          //console.log("BLOCKED.")
          setBlocked(true);
        }
        else {
          setBlocked(false);
        }
      }
    }
    //console.log("END OF BLOCK CHECKING ASYNC FUNCTION");
    // Don't set isLoaded here, it's now controlled by getPost
  }

  async function handleBlockCheck() {
    const result = blockChecking();
  }

  useLayoutEffect(() => {
    handleBlockCheck();
  })
 
  useEffect(()=> {
    // console.log(`ACCOUNT BLOCKED STATUS: ${accountBlocked}`);
    // console.log(`CURRENT USER IS BLOCKED STATUS: ${blocked}`);
    // console.log(`POST IS BLOCKED STATUS: ${currBlocked}`);
  },[currBlocked, blocked])
   

  // handleBlockCheck();



  const handleCommentSubmit = async (e) => {
    e.preventDefault();

    const newCommentData = {
      authorID: sessionStorage.getItem("user"),
      content: newComment,
      parentID: id, // this post's ID
      attributes: {},
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}/posts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(newCommentData),
      });

      const result = await response.json();

      setNewComment(""); // Clear textarea
      getPost(id);       // Refresh post (and comments) after submission
      loadComment("");
    } catch (err) {
      console.error("Error submitting comment:", err);
      setErrorMessage("Failed to submit comment.");
    }
  };


  // --- Handler: Review Text Change with Word Count Validation ---
  const handleReviewChange = (e) => {
    const text = e.target.value;
    const words = text.split(/\s+/).filter(Boolean);
    setNewComment(text);

    const trimmedComment = newComment.trim();
    const wordCount = trimmedComment.split(/\s+/).filter(Boolean).length;

    if (!trimmedComment) {
      setErrorMessage("You cannot submit an empty comment.");
      return;
    }

    if (words.length > MAX_REVIEW_WORDS) {
      setErrorMessage(`Review cannot exceed ${MAX_REVIEW_WORDS} words.`);
    } else {
      setErrorMessage("");
    }
  };




  // function used to load the comments of a post given the post id from the props
  const loadComment = () => {
    if (sessionStorage.getItem("token")) {
      let url = process.env.REACT_APP_API_PATH + "/posts?parentID=" + id;

      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((res) => res.json())
        .then((result) => {
          result.forEach((comment) => {
            if (!commentUsernames[comment.authorID]) {
              fetchAuthorDetails(comment.authorID);
            }
          })

          if (result) {
            setNewComment("");
            // console.log(result[0]);
            setComments(result[0]);

            // Don't modify postImage here - this was causing the race condition
            // removed: setPostImage();
            
            //setPostTitle(result[0].length);
            result[0].forEach(c => fetchCommentAuthorDetails(c.authorID));
          }
        })
        .catch((err) => {
          // console.log("ERROR loading posts");
        });
    }
  };

  const handleDeleteComments = (commentID, commentAuthorID) => {
    const currentUserID = sessionStorage.getItem("user");

    if (currentUserID != postAuth && currentUserID != commentAuthorID) {
      setErrorMessage("You do not have permission to delete this comment.");
      return;
    }

    fetch(`${process.env.REACT_APP_API_PATH}/posts/${commentID}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })

      .then(() => {
        loadComment(); // Refresh comments
      })
      .catch((err) => {
        console.error("Error deleting comment:", err);
        setErrorMessage("Failed to delete comment.");
      });
  };

  const fetchCommentAuthorDetails = (authorID) => {
    if (!authorID || commentUsernames[authorID]) return;
  
    const token = sessionStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
    };
  
    if (token) {
      headers["Authorization"] = "Bearer " + token;
    }
  
    fetch(`${process.env.REACT_APP_API_PATH}/users/${authorID}`, {
      method: "GET",
      headers,
    })
      .then((res) => res.json())
      .then((result) => {
        if (result && result.attributes && result.attributes.username) {
          setCommentUsernames((prev) => ({
            ...prev, // 👈 spread the previous usernames
            [authorID]: result.attributes.username, // 👈 store by user ID
          }));
        } else {
          setCommentUsernames((prev) => ({
            ...prev,
            [authorID]: `User ${authorID}`,
          }));
        }
      })
      .catch((error) => {
        console.error("Error fetching author details:", error);
        setCommentUsernames((prev) => ({
          ...prev,
          [authorID]: `User ${authorID}`,
        }));
      });
  };
  





  // Render the main post body with author information, delete icon (if applicable),
  // post content, and the comment display section including tags, reactions, and comments.
  if (open) {
    return (
      <BlockModal></BlockModal>
    )
  }
  if (blocked && isLoaded) {
    return (<div>
      <h1>Content Unavailiable</h1>
    </div>
    )
  }

  if (accountBlocked && isLoaded) {
    return(<div>
      <h1>This post is from an account you blocked!</h1>
    </div>
    )
  }
  if (currBlocked && isLoaded) {
    return(<div>
      <h1>You have blocked this post!</h1>
      <button className="Back" onClick={handleUnblockPost}>Unblock</button>
    </div>
    )
  }

  return (
    <div>
      {(!isLoaded) ? (
        <div className="loading">Loading...</div>
      ) : (
        <>
          <head>
            <link rel="preconnect" href="https://fonts.googleapis.com"></link>
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin></link>
            <link href="https://fonts.googleapis.com/css2?family=Fredericka+the+Great&family=Fredoka:wght@500&family=Urbanist:ital,wght@0,500;1,500&display=swap" rel="stylesheet"></link>
          </head>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <h2 className="post-view-title">Viewing Post
          {openBlock && (
                    <a onClick={closeOpenBlock}><img className="dropdown" src={dropdown} alt="" /></a>
                    )}

                    {!openBlock && (
                    <a onClick={handleOpenBlock}><img className="dropdown" src={dropdown} alt="" /></a>
                    )}
            
            {/* <label className="privacy-label">


              <img
                checked={privatePost}
                onChange={handlePrivacy}
              />
              {privatePost ?
                <div>
                  <img className="Locking_Photo" src={lock} alt="Locking"></img>
                  {openBlock && (
                  <button id="drop-block" className="Back" onClick={handleOpen}>Block</button>
                  )}
                </div>

                :
                <div>
                  <img className="Locking_Photo" src={unlock} alt="Locking"></img>
                  {openBlock && (
                  <button id="drop-block" className="Back" onClick={handleOpen}>Block</button>
                  )}
                </div>
                }

            </label> */}
            

          </h2>

          <div className="container">
          
            {postTitle !== "" ? (
              <div className="together">
                <div className="togetherAfter">
                  <h3 className="user-id">
                    Posted by:{" "}
                    <Link to={`/user/${authorId}`} className="author-link">
                      {authorUsername}
                    </Link>
                    <br></br> 

                  </h3>
                

                  

                  <h1 className="titleAfter">{postTitle}</h1>

                  {/* Fixed image display with improved sizing */}
                  <div className="post-image-container" style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "20px 0",
                    minHeight: "300px",
                    backgroundColor: postImage ? "transparent" : "#f0f0f0",
                    borderRadius: "8px",
                    overflow: "hidden"
                  }}>
                    {postImage ? (
                      <img
                        src={postImage}
                        alt="Post Image"
                        className="PostingImage"
                        style={{
                          width: "100%",
                          maxWidth: "500px",
                          height: "auto",
                          objectFit: "contain",
                          borderRadius: "8px"
                        }}
                        onError={(e) => handleImageError(e)}
                      />
                    ) : (
                      <div className="withoutImage" style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "300px"
                      }}>
                        <p>No image available</p>
                      </div>
                    )}
                  </div>

                  {/* Rating display using StarGen component */}
                  <div className="rating">
                    <StarGen rating={overallRating} />
                  </div>

                  <p className="reviewAfter" style={{
                    fontSize: "16px",
                    lineHeight: "1.5",
                    margin: "20px 0"
                  }}>{postContent}</p>

                  <div className="button-container">
                    <button className="Back" onClick={() => navigate(`/`)}>Back</button>
                    {sessionStorage.getItem("user") == postAuth &&
                      <button onClick={handleEdit} className="edit-button">
                        Edit
                      </button>
                    }
                  </div>

                  {sessionStorage.getItem("user") == postAuth &&
                    <button onClick={() => setShowModal(true)}
                      className="delete-button">
                      Delete Post</button>
                  }
                  {/* </div> */}

                  {sessionStorage.getItem("user") && (

                  <div className="comment-section">
                    <button onClick={() => setShowCommentBox(!showCommentBox)} className="comment-toggle">
                      <img src={commentButton} alt="Comment" className="comment-icon" />

                    </button>


                    {showCommentBox && (

                      <form onSubmit={handleCommentSubmit} className="comment-box-form">
                        <label>
                          Add a Comment to Post {parent}
                          <br />
                          <textarea
                            className="Comment_Box"
                            placeholder="Comment on their post"
                            value={newComment}
                            rows="10"
                            onChange={handleReviewChange}
                          />
                          <p className="Word_Count">
                            {newComment.split(/\s+/).filter(Boolean).length} / {MAX_REVIEW_WORDS} words
                          </p>
                        </label>
                        <br />

                        <button className="submitComment" type="post Comment" value="Submit Comment" disabled={!newComment.trim()}>
                          Post Comment
                        </button>
                        <br />
                        {postMessage}

                      </form>

                    )}

                  </div>
                  )}

                  {comments.map(c =>
                    <div key={c.id} className="comment-box">
                      <div className="comment-author">
                      Posted by:{" "}
                      <Link to={`/user/${c.authorID}`} className="author-link">
                      {commentUsernames[c.authorID] || `User ${c.authorID}`}
                        {/* {[c.authorID]}{commentUsernames} */}
                      </Link>
                      </div>
                      <div className="comment-content">
                        {c.content}
                        {(sessionStorage.getItem("user") == postAuth || sessionStorage.getItem("user") == c.authorID) && (
                          <button onClick={() => handleDeleteComments(c.id, c.authorID)} className="delete-comment">
                            <img src={trash} alt="Delete Comment" className="comment-icon" />
                          </button>
                        )}
                      </div>
                    </div>)
                  }
                </div>




                {/* Information section */}
                <div className="Information" style={{
                  backgroundColor: '#dcdcdcdc',
                  borderRadius: '12px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',

                }}>
                  <div style={{ marginBottom: '24px' }}>
                    {restaurantId ? (
                      <Link to={`/restaurant/${restaurantId}`} style={{
                        textDecoration: 'none',
                        display: 'inline-block'
                      }}>
                        <h1 style={{
                          fontSize: '32px',
                          fontWeight: '600',
                          marginBottom: '8px',
                          color: '#005BBB', // Blue color to indicate link
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          transition: 'color 0.2s ease'
                        }}>
                          {restaurantName}
                          <span style={{
                            fontSize: '20px',
                            color: 'black'
                          }}>
                            →
                          </span>
                        </h1>
                      </Link>
                    ) : (
                      <h1 style={{
                        fontSize: '24px',
                        fontWeight: '600',
                        marginBottom: '8px',
                        color: '#2c3e50'
                      }}>{restaurantName}</h1>
                    )}
                    <h2 style={{
                      fontSize: '20px',
                      fontWeight: '500',
                      color: '#34495e',
                      marginBottom: '16px'
                    }}>{dishName}</h2>
                  </div>

                  {/* Menu Image Section */}
                  <div style={{
                    marginBottom: '24px'
                  }}>
                    <h2 style={{
                      fontSize: '18px',
                      fontWeight: '500',
                      color: '#2c3e50',
                      marginBottom: '12px'
                    }}>Image from Menu</h2>
                    <div style={{
                      height: '350px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: dishImage ? 'transparent' : '#edf2f7',
                      borderRadius: '8px',
                      overflow: 'hidden'
                    }}>
                      {dishImage ? (
                        <img
                          src={dishImage}
                          alt={dishName}
                          style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                            borderRadius: '8px'
                          }}
                          onError={(e) => handleImageError(e, `${process.env.PUBLIC_URL}/restaurant-images/placeholder.jpg`)}
                        />
                      ) : (
                        <p style={{
                          color: '#718096',
                          fontStyle: 'italic',
                          textAlign: 'center'
                        }}>
                          No menu image available
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Categories Section */}
                  {categories && categories.length > 0 && (
                    <div style={{ marginBottom: '24px' }}>
                      <h2 style={{
                        fontSize: '18px',
                        fontWeight: '500',
                        color: '#2c3e50',
                        marginBottom: '12px'
                      }}>Categories/Tags</h2>
                      <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '8px',
                        lineHeight: '1.5'
                      }}>
                        {categories.map((category, index) => {
                          // Define tag type based on category
                          const tagType = category.toLowerCase().replace(/\s+/g, '-');
                          let backgroundColor = '#e2e8f0';
                          let textColor = '#4a5568';

                          // Spice Level Colors
                          if (tagType === 'hot') {
                            backgroundColor = '#ffcdd2';
                            textColor = '#c62828';
                          } else if (tagType === 'medium') {
                            backgroundColor = '#ffe0b2';
                            textColor = '#ef6c00';
                          } else if (tagType === 'mild') {
                            backgroundColor = '#fff9c4';
                            textColor = '#f57f17';
                          } else if (tagType === 'no-spice') {
                            backgroundColor = '#cfd8dc';
                            textColor = '#455a64';
                          }
                          // Dietary Colors
                          else if (tagType === 'veggie' || tagType === 'vegetarian' || tagType === 'vegan') {
                            backgroundColor = '#c8e6c9';
                            textColor = '#2e7d32';
                          } else if (tagType === 'gluten-free') {
                            backgroundColor = '#bbdefb';
                            textColor = '#0d47a1';
                          } else if (tagType === 'soy-free') {
                            backgroundColor = '#e1bee7';
                            textColor = '#6a1b9a';
                          } else if (tagType === 'dairy-free') {
                            backgroundColor = '#ffccbc';
                            textColor = '#d84315';
                          } else if (tagType === 'nut-free') {
                            backgroundColor = '#d1c4e9';
                            textColor = '#4527a0';
                          }
                          // Cuisine Colors
                          else if (tagType === 'mexican') {
                            backgroundColor = '#FFECB3';
                            textColor = '#FF8F00';
                          } else if (tagType === 'chinese') {
                            backgroundColor = '#FFCDD2';
                            textColor = '#B71C1C';
                          } else if (tagType === 'japanese') {
                            backgroundColor = '#F3E5F5';
                            textColor = '#6A1B9A';
                          } else if (tagType === 'korean') {
                            backgroundColor = '#B2EBF2';
                            textColor = '#00838F';
                          } else if (tagType === 'indian') {
                            backgroundColor = '#FFECB3';
                            textColor = '#E65100';
                          } else if (tagType === 'american') {
                            backgroundColor = '#C5CAE9';
                            textColor = '#283593';
                          } else if (tagType === 'italian') {
                            backgroundColor = '#DCEDC8';
                            textColor = '#558B2F';
                          }
                          // Contains/Allergens
                          else if (tagType === 'contains-seafood') {
                            backgroundColor = '#b2dfdb';
                            textColor = '#00695c';
                          }

                          return (
                            <span key={index} style={{
                              backgroundColor: backgroundColor,
                              color: textColor,
                              padding: '4px 12px',
                              borderRadius: '4px',
                              fontSize: '0.85em',
                              fontFamily: "'Urbanist', sans-serif",
                              whiteSpace: 'nowrap',
                              display: 'inline-block',
                              verticalAlign: 'middle',
                              lineHeight: '1.3'
                            }}>
                              {category}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Description Section */}
                  <div>
                    <h2 style={{
                      fontSize: '18px',
                      fontWeight: '500',
                      color: '#2c3e50',
                      marginBottom: '12px'
                    }}>Description</h2>
                    <p style={{
                      color: '#4a5568',
                      lineHeight: '1.6',
                      whiteSpace: 'pre-wrap',
                      fontSize: '16px'
                    }}>
                      {dishDescription || "No description available"}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="loading">Loading...</div>
            )}
          </div>
          {showModal && (
            <div className="modal">
              <div className="modal-content">
                <p>Are you sure you want to delete this post?</p>
                <button className="modalDelete" onClick={handleDelete}>Yes, Delete</button>
                <button className="modalCancel" onClick={() => {
                  // console.log("Cancel button clicked");
                  setShowModal(false)
                }}>Cancel</button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default Post;

